<template>
	<div>
		<Spin fix>
			<Icon type="ios-loading" size="40" class="demo-spin-icon-load"></Icon>
			<p style="line-height: 40px;">正在获取用户信息，请稍后....</p>
		</Spin>
	</div>
</template>

<script>
	import {
		naliDct,
		knowledgeIsCollect,
		userDetails
	} from '../../request/api.js';
	import loading from '../../components/tools/loading.vue';
	import {
		setToken
	} from '../../libs/util.js';
	export default {
		components: {
			loading
		},
		data() {
			return {
				Phone: ''
			}
		},
		methods: {
			login(phone) {
				const _this = this;
				naliDct({
					userName: phone
				}).then(res => {
					setToken(JSON.stringify(res.token))
					setTimeout(() => {
						_this.getUserInfo()
					}, 200)
				}).catch(err => {
					this.$Modal.confirm({
						title: '错误',
						content: err.message,
						okText: '重试',
						cancelText: '返回首页',
						onOk: () => {
							window.location.reload();
						},
						onCancel: () => {
							this.$router.push('/')
						}
					});
				})
			},
			// 获取用户信息
			getUserInfo() {
				const _this = this;
				userDetails().then(userres => {
					// 收藏
					let sc = userres.member.collects;
					let scVideo = {
						scNum: sc.length,
						scList: sc
					}
					// 预约
					let yy = userres.member.orders;
					let yyVideo = {
						yyNum: yy.length,
						yyList: yy
					}
					// 知识库
					let zskSc = [];
					knowledgeIsCollect(userres.member.memberId).then(knowres => {
						zskSc = knowres
					}).catch(err => {
						zskSc = []
					})
					let scZsk = {
						zskScNum: zskSc.length,
						zskScList: zskSc
					}
					const ArxsysUser = {
						loginName: userres.member.loginName,
						nickname: userres.member.nickname,
						type: userres.member.type,
						integral: userres.member.integral,
						photo: userres.member.photo,
						memberId: userres.member.memberId,
						scVideo: scVideo,
						yyVideo: yyVideo,
						scZsk: scZsk
					};
					this.$store.commit('updateUserData', ArxsysUser)
					this.$Message.success('你好，欢迎登录!正在跳转首页');
					setTimeout(() => {
						_this.$router.push('/')
					}, 1000)
				})
			}
		},
		mounted() {
			var Phone = this.$route.query.Phone;
			this.login(Phone)
		}
	}
</script>

<style>
	.demo-spin-icon-load {
		animation: ani-demo-spin 1s linear infinite;
	}

	@keyframes ani-demo-spin {
		from {
			transform: rotate(0deg);
		}

		50% {
			transform: rotate(180deg);
		}

		to {
			transform: rotate(360deg);
		}
	}
</style>
<style lang="less">
	.ivu-modal-wrap {
		display: flex;
		align-items: center;
		justify-content: center;

		.ivu-modal {
			top: 0;
		}
	}
</style>
